import Vue from 'vue'
import {mapGetters,mapActions} from 'vuex'
import ApiClientsService from 'js/services/api/api-clients.js'
import DisableMedia from 'js/components/disable-media'
import ProfileRequests from './profile-requests'
import ViewRequests from './view-requests'
import DocumentIdentifyTypeService from 'js/services/api/document_indentify_types.js'

import template from './index.pug'

const LESS_THAN = 'less_than'

export default Vue.extend({
  name: 'payment-method-page',
  template: template(),
  components: {
    DisableMedia,
    ProfileRequests,
    ViewRequests
  },
  data() {
    const vm = this

    return {
      fields: [
        'Name', 'SurName1', 'SurName2', 'DocumentType', 'RUTPassport', 'Birthday', 'Phone',
        'Address', 'PostalCode', 'Email'
      ],
      editableFields: [
        'Name', 'SurName1', 'SurName2', 'RUTPassport', 'Birthday', 'Phone', 'Address', 'PostalCode',
        'Email'
      ],
      profileForm: {
        DocumentType: undefined,
        RUTPassport: undefined,
        Name: undefined,
        SurName1: undefined,
        SurName2: undefined,
        Birthday: undefined,
        Phone: undefined,
        Address: undefined,
        PostalCode: undefined,
        Email: undefined,
        documentIdentifyType: undefined
      },
      fieldsErrors: vm.resetFieldErrors(),
      accountLoaded: false,
      datepickerConfig: {
        allowInput: true,
        formatDate(date) { return moment(date).format('DD/MM/YYYY') },
        parseDate(date) { return moment(date, 'DD/MM/YYYY').toDate() },
        disableMobile: true
      },
      okProfile: false,
      loadingProfile: false,
      showDisableMediaBox: false,
      media: {},
      hasProfileAccreditation: false
    }
  },
  computed: {
    ...mapGetters(['showProfileAccreditationRequests']),

    documentTypeOptions() {
      if (this.documentIdentifyType !== undefined) {
        return this.documentIdentifyType.map(documentType => (
          {
            label: this.$t(`everilionRegisterForm.rutPassport.documentIdentifyType.${documentType.code}`),
            value: documentType.code
          }
        ))
      }

      return []
    }
  },
  watch: {
    $currentAccount() {
      this.checkIfCanRequestProfile()
    }
  },
  created() {
    this.checkIfCanRequestProfile()
    this.getDocumentIdentifyTypes()
    this.closeViewProfileAccreditationRequest()
  },
  methods: {
    ...mapActions(['closeViewProfileAccreditationRequest']),
    
    async getDocumentIdentifyTypes() {
      const params = {
        per: 0,
        order_dir: 'asc',
        order_by: 'code'
      }
      const {data} = await DocumentIdentifyTypeService.index(params)    
      this.documentIdentifyType = data.filter(docs => this.$currentAppConfig.document_identify_type_ids.includes(docs.id))
    },
    openDisableMediaBox() {
      this.showDisableMediaBox = true
    },

    checkIfCanRequestProfile() {
      const vm = this

      // Tengo cuenta en el municipio actual
      if (vm.$currentAccount) {
        vm.loadingProfile = true

        const params = {
          administrative_area_id: vm.$currentAccount.administrative_area_id,
          rut: vm.$currentAccount.rut
        }

        ApiClientsService.clientMediaInfo(params).then(() => {
          vm.okProfile = true
          vm.getProfile()
        }, () => {
          vm.loadingProfile = false
        })
      }
    },

    getProfile() {
      const vm = this

      if (vm.$currentAccount) {
        const params = {
          administrative_area_id: vm.$currentAccount.administrative_area_id,
          rut: vm.$currentAccount.rut
        }

        ApiClientsService.clientAccount(params).then(client => {
          const data = {}

          if (client.Birthday) {
            client.Birthday = moment(client.Birthday).format('DD/MM/YYYY')
          }
          _.each(vm.fields, key => {
            data[key] = client[key]
          })
          
          vm.profileForm = data
          vm.loadingProfile = false
          vm.accountLoaded = true
        }, () => {
          vm.loadingProfile = false
        })

        vm.hasProfileAccreditation = vm.administrativeArea.config.has_profile_accreditation
      }
    },

    reloadView() {
      const vm = this
      Vue.store.dispatch('loadCurrentUser').then(() => {
        vm.checkIfCanRequestProfile()
      })
    },

    updateProfile() {
      const vm = this

      vm.fieldsErrors = vm.resetFieldErrors()

      if (vm.validateRegisterForm()) {
        const data = {}

        // Añadimos a data los campos del formulario
        _.each(vm.editableFields, key => {
          data[key] = vm.profileForm[key]
        })

        const params = {
          administrative_area_id: vm.administrativeArea.id,
          client: data
        }

        // Convertimos la fecha al formato de Everilion
        params.client.Birthday = moment.utc(
          moment(data.Birthday, 'DD/MM/YYYY').format('YYYY-MM-DD')
        ).valueOf()

        ApiClientsService.updateClient(params).then(() => {
          vm.$notifications.send({
            id: 'payment-medias-success',
            text: vm.$t('paymentMedias.success'),
            type: 'success',
            close: true
          })
        }, response => {
          this.fieldsErrors = response.data.errors
          const min_age_years = vm.administrativeArea.config.min_age_years
          if (response.data.errors.birthdate === LESS_THAN) {
            this.fieldsErrors.Birthday = vm.$t(`everilionRegisterForm.registerEverilion.errors.birthdate.${response.data.errors.birthdate}`, 
              {count: `${min_age_years}`})
          }
        })
      }
    },

    validateRegisterForm() {
      const vm = this

      let valid = true

      const fieldsFilledByUser = [
        'Name', 'SurName1', 'Birthday', 'Email', 'Phone', 'PostalCode'
      ]

      _.each(fieldsFilledByUser, field => {
        const typedValue = vm.profileForm[field]

        if (!typedValue || !$.trim(typedValue)) {
          vm.fieldsErrors[field] = vm.$t('paymentMedias.errors.invalidFields')
          valid = false
        }
      })

      return valid
    },

    resetFieldErrors() {
      return {
        Name: undefined,
        SurName1: undefined,
        SurName2: undefined,
        Birthday: undefined,
        Email: undefined,
        Phone: undefined,
        Address: undefined,
        PostalCode: undefined
      }
    }
  },
  mounted(){

    setTimeout(
      () => {
        var boton = document.getElementById("unregister_link");
       
        var left = this
        // Agregar un listener para el evento focus
        boton.addEventListener('focus', function() {
          var textListen= left.$t('paymentMedias.unregister')
          left.escucharAudio(textListen )
          
        });
        var boton2 = document.getElementById("GuardarCambios");
       
        var left = this
        // Agregar un listener para el evento focus
        boton2.addEventListener('focus', function() {
          var textListen= left.$t('general.saveChange')
          left.escucharAudio(textListen )
          
        });


        

      },6000)
      
  }
})
